import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect } from "react";
import ConfirmAlertModal from "../../Modals/confirmAlertModal";
import { Container } from "react-bootstrap";
import GlobalColumnDefinations, { getHeader_FieldName } from "../../utility/grid/definitions/AgGridDefination";
import GridMaster from "../../utility/grid/GridMaster";
import Toaster from "../../utility/ui/notifications/Toaster";
import { getPendingReq } from "../../../Services/trainingRequisition-service";
import ActioRenderTrainingReq from "../../utility/grid/renderers/ActionRenderers/ActioRenderTrainingReq";

export const TrainingReqApproval = forwardRef((props, ref) => {
  const childRef = useRef();
  let formName = "TrainingRequisition";
  const [filteredResult, setFilteredResult] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [setAction] = useState("");
  const [setdata] = useState("");
  const [reload] = useState(false);
  const [show1, setShow1] = useState(false);
  let userId = sessionStorage.getItem("User");

  const handleEdit = (row) => {
    props.setAction("Edit");
    props.setRowData(row);
    props.setShowForm(true);
    props.setCalledFrom("Approval")
  };

  const headerName = (field) => {
    let name = getHeader_FieldName(field, props.tmpcolumnDefs, "getHeader");
    return name;
  };

  const fieldName = (header) => {
    let name = getHeader_FieldName(header, props.tmpcolumnDefs, "getField");
    return name;
  };

  function setRefre() {
    props.setRefe(childRef)
  }

  const fetchTrainingRequisition = async () => {
    try {
      // Get user role from session storage
      const userRole = sessionStorage.getItem("Role");
      
      // Only fetch data if user has WE role
      if (userRole === "WE") {
        const result = await getPendingReq();
        setFilteredResult(result || []);
      } else {
        console.log("User does not have WE role, no pending requests to show");
        setFilteredResult([]);
      }
    } catch (error) {
      console.error('Error fetching training requisitions:', error);
      setFilteredResult([]);
    }
  };

  const fetchColumnDefns = async () => {
    try {
      const result = GlobalColumnDefinations(props.tmpcolumnDefs);
      if (result && result.length >= 2) {
        result[result.length - 2].cellRenderer = actionRenderer;
      }
      setColumnDefs(result || []);
    } catch (error) {
      console.error('Error fetching column definitions:', error);
      setColumnDefs([]);
    }
  };

  useImperativeHandle(ref, () => ({
    reload: async () => {
      fetchTrainingRequisition();
      setRefre();
      fetchColumnDefns();
    },
  }));

  useEffect(() => {
    fetchTrainingRequisition();
    setRefre();
    fetchColumnDefns();
  }, [reload])

  const handleClose = () => {
    setShow1(false);
  };

  const actionRenderer = (params) => {
    return (
      <ActioRenderTrainingReq
        selectedData={params}
        handleEditEvent={(params) => handleEdit(params.data)}
        handleDeleteEvent={(params) => {
          setdata(params.data);
          setShow1(true);
          setAction("Delete");
        }}
      />
    );
  };

  return (
    <Container fluid>
      <ConfirmAlertModal
        formName={formName}
        show={show1}
        handleClose={handleClose}
      />
      <GridMaster
        rowDetails={filteredResult}
        colDetails={columnDefs}
        fieldNames={fieldName}
        headerNames={headerName}

        setExcelData={props.setExcelData}
        ref={childRef}
        height="380px"
      />

      <Toaster />
    </Container>
  )
})